
































































































    import {Component, Vue} from 'vue-property-decorator';
    import {MitarbeiterService} from "@/services/mitarbeiter-service";
    import {Person} from "@/models/person-model";
    import {containsWoCaseMultipleFn} from "@/helper/global-helper";
    import {PageStore, PageStores} from "@/store/modules/page-store";
    import {UserModule, UserStore} from "@/store/modules/currentuser-store";
import { GuardileoVueComponent } from '@/lib';

    @Component({})
    export default class DatenschutzbeauftragterList extends GuardileoVueComponent {
        private service!: MitarbeiterService;
        public items: Person[] = [];
        private loading: boolean = true;
        public pageStore: PageStore = PageStores.datenschutzbeauftragter;
        public userStore: UserModule = UserStore;

        get filteredItems(): Person[] {
            return this.items.filter((x:Person)=> containsWoCaseMultipleFn(this.pageStore.filter, x.FullName, x.Email, x.Firma, x.Funktion, x.Ort, x.Plz, x.Strasse, x.Telefon));
        }

        created() {
            this.service = new MitarbeiterService();
        }

        async mounted() {
            this.items = await this.service.GetListDatenschutzbeauftragte();
            this.loading = false;
        }

        get konzerngesellschaftenActivated(): boolean
        {
            return UserStore.currentKunde.ZusatzfunktionAbweichenderDatenschutzbeauftragter;
        }

        get darf_Datenschutzbeauftragten_hinzufuegen(): boolean {
            return this.hat_Berechtigung('Datenschutzbeauftragte_verwalten');
        }
    }
